<template>
  <nav class="top-nav">
    <v-row class="ma-0">
      <v-col cols="7" class="pa-0">
        <div class="nav-items">
          <ul>
            <li>
              <div class="top-menu"
                :class="activeDashView === 'overview' ? 'top-menu--active' : ''"
                @click="activeDashView = 'overview';changeView()"
              >
                <div class="top-menu__icon">
                  <i class="las la-chart-pie"></i>
                </div>
                <div class="top-menu__title"> Overview </div>
              </div>
            </li>
            <li>
              <div class="top-menu"
                @click="activeDashView = 'touchpoints-snapshot';changeView()"
                :class="activeDashView === 'touchpoints-snapshot'
                || activeDashView === 'touchpoints-analysis' ? 'top-menu--active' : 'menu'"
              >
                <div class="top-menu__icon">
                  <i class="las la-route"></i>
                </div>
                <div class="top-menu__title">
                  Critical touchpoints
                  <!-- <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down top-menu__sub-icon">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg> -->
                </div>
              </div>
            </li>
            <li>
              <div class="top-menu"
                :class="activeDashView === 'disengaged-snapshot'
                || activeDashView === 'disengaged-emp-to-meet'
                || activeDashView === 'disengaged-sentiment-analysis'
                ? 'top-menu--active' : 'menu'"
                @click="activeDashView = 'disengaged-snapshot';changeView()"
              >
                <div class="top-menu__icon">
                  <i class="lar la-user"></i>
                </div>
                <div class="top-menu__title">
                  Disengaged employees
                  <!-- <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down top-menu__sub-icon"><polyline points="6 9 12 15 18 9"></polyline></svg> -->
                </div>
              </div>
            </li>
            <li>
              <div class="top-menu"
                :class="activeDashView === 'txt-analysis' ? 'top-menu--active' : ''"
                @click="activeDashView = 'txt-analysis';changeView()"
              >
                <div class="top-menu__icon">
                    <i class="lab la-searchengin"></i>
                </div>
                <div class="top-menu__title">Txt analysis</div>
              </div>
            </li>
            <li>
              <div class="top-menu"
                :class="activeDashView === 'anonymous-snapshot'
                || activeDashView === 'anonymous-message'
                ? 'top-menu--active' : ''"
                @click="activeDashView = 'anonymous-snapshot';changeView()"
              >
              <div class="top-menu__icon">
                <i class="las la-user-secret"></i>
                </div>
                <div class="top-menu__title">
                  Anonymous
                  <!-- <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down top-menu__sub-icon"><polyline points="6 9 12 15 18 9"></polyline></svg> -->
                </div>
              </div>
            </li>
          </ul>
        </div>
      </v-col>
      <v-col cols="5" class="pa-0 d-flex justify-end">
        <div class="filter-bar d-flex"
          :class="!checkPermission(['data_export']) ? 'disable-action' : ''"
          v-if="activeDashView !== 'anonymous-snapshot'
            && activeDashView !== 'anonymous-message'"
        >
          <div v-if="downloadingFlag" class="d-flex box-container px-3" style="height: 2.4rem;">
            <v-btn :loading="true" icon></v-btn>
            <div class="pl-1 d-flex align-center">downloading...</div>
          </div>
          <v-btn
            v-if="!downloadingFlag"
            class="box-container zoom-in mx-1"
            :disabled="!checkPermission(['data_export'])"
            @click="exportDialog = !exportDialog"
          >
            <v-icon small class="mr-2">las la-cloud-download-alt</v-icon>
            <span>Export dashboard</span>
          </v-btn>
          <!-- <v-btn
            v-if="!downloadingFlag"
            class="box-container zoom-in mx-1 shortView"
            @click="exportDialog = !exportDialog"
          >
            <v-icon small class="mr-2">las la-cloud-download-alt</v-icon>
          </v-btn> -->
          <!-- <v-btn
            color="white"
            class="box-container zoom-in mx-1 shortView"
            @click.stop="toggleDashFilter"
          >
            <i class="las la-filter mr-1"></i>
          </v-btn> -->
          <v-btn
            color="white"
            class="box-container zoom-in mx-1"
            @click.stop="toggleDashFilter"
          >
            <i class="las la-filter mr-1"></i>
            <span>Filter</span>
          </v-btn>
          <v-btn
            v-if="isFilterApplied"
            class="box-container zoom-in mx-1"
            @click="resetDashFilters"
          >
            <v-icon color="primary">las la-sync-alt</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="exportDialog" scrollable max-width="600px">
      <v-card>
        <v-card-title>Export dashboard</v-card-title>
        <v-card-subtitle>
          Please select what all data you want to export
        </v-card-subtitle>
        <v-card-text style="height: 250px">
          <div>
            <v-checkbox hide-details v-model="dashOverview">
              <div class="export-data-heading" slot="label">
                Dashboard overview
              </div>
            </v-checkbox>
          </div>
          <div class="export-data-heading mt-4">Critical touchpoints</div>
          <v-row no-gutters class="mt-n3">
            <v-col cols="4">
              <v-checkbox
                v-model="touchpointSnapshot"
                label="Snapshot"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="4">
              <v-checkbox
                v-model="touchpointHeatmap"
                label="Heat map"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <div class="export-data-heading mt-4">Disengaged employees</div>
          <v-row no-gutters class="mt-n3">
            <v-col cols="4">
              <v-checkbox
                v-model="disengagedSnapshot"
                label="Snapshot"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="4">
              <v-checkbox
                v-model="disengagedMeet"
                label="Employees to meet"
                hide-details
              ></v-checkbox>
            </v-col>
            <!-- <v-col cols="4">
              <v-checkbox
                v-model="disengagedAnalysis"
                label="Sentiment analysis"
                hide-details
              ></v-checkbox>
            </v-col> -->
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-space-between">
          <v-btn text @click="exportDialog = false">Close</v-btn>
          <v-btn
            color="primary"
            @click="downloadReport()"
          >
            <v-icon color="white" class="mr-2">las la-cloud-download-alt</v-icon>
            Export
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </nav>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';

export default {
  name: 'DashboardTopBar',

  components: {
  },

  props: {
    isFilterApplied: {
      required: true,
      type: Boolean,
      defalut: false
    },
    dashTab: {
      required: true,
      type: String,
      default: ''
    }
  },

  data () {
    return {
      downloadingFlag: false,
      activeDashView: '',
      exportDialog: false,
      dashOverview: false,
      touchpointSnapshot: false,
      touchpointHeatmap: false,
      disengagedSnapshot: false,
      disengagedMeet: false,
      disengagedAnalysis: false
      // items: ['Filter 1', 'Filter 2', 'Filter 3', 'Filter 4']
    };
  },

  watch: {
    // activeDashView: {
    //   immediate: false,
    //   handler () {
    //     // console.log('this.$router', this.$route.query);
    //     // this.$emit('onClickDashTab', this.activeDashView);
    //   }
    // },
    $route: {
      deep: true,
      immediate: true,
      handler () {
        if (this.$route.query && this.$route.query.tab) {
          this.activeDashView = this.$route.query.tab;
        }
      }
    },
    dashTab () {
      this.activeDashView = this.dashTab;
    }
  },

  beforeMount () {
    // if (this.$route.query) {
    //   if (this.$route.query.tab) {
    //     this.activeDashView = this.$route.query.tab;
    //   } else {
    //     this.activeDashView = 'overview';
    //   }
    // }
    // if (this.$route.query) {
    //   if (this.$route.query.tab) {
    //     this.activeDashView = this.$route.query.tab;
    //   }
    // }
  },

  computed: {
    ...mapState({
      user: state => state.user,
      updateDashboardFilters: state => state.updateDashboardFilters
    })
  },

  methods: {
    checkPermission (permission) {
      let flag = false;
      this.$lodash.each(this.user.permissions, (perm) => {
        this.$lodash.each(permission, (v) => {
          if (v === perm) {
            flag = true;
          }
        });
      });
      return flag;
    },
    downloadReport (reportGenerationType) {
      this.downloadingFlag = true;
      this.exportDialog = false;
      let reportFilters = {};
      let dashboardFilters = {};
      // send filters in api call
      let newFilter = {};
      if (this.$route.query.filters) {
        dashboardFilters = JSON.parse(this.$route.query.filters);
      }
      const filters = Object.assign({}, dashboardFilters);
      if (filters && filters.filters) {
        delete filters.filters;
      }
      if (dashboardFilters && dashboardFilters.filters) {
        this.$lodash.each(dashboardFilters.filters, (v, k) => {
          if (v && v.length > 0) {
            newFilter = {
              [`user__profile__${k}__in`]: v.join()
            };
            reportFilters = {
              ...reportFilters,
              ...newFilter
            };
          }
        });
      }
      let selectedData = [];
      let selectedType = [];
      if (this.dashOverview) {
        const temp = ['overall_mood', 'engagement_score', 'disengaged_employees_stats', 'company_employee_reach_stats', 'chat_response_stats', 'chat_response_trends', 'user_participation_stats', 'user_participation_trends', 'drivers_analysis', 'sub_drivers_analysis', 'company_mood_breakdown', 'monthwise_engagement_vs_mood_trend'];
        selectedData = [...selectedData, ...temp];
        selectedType = [...selectedType, 'dashboard'];
      }
      if (this.touchpointSnapshot) {
        const temp = ['id', 'title', 'status', 'stageIndex', 'createdAt', 'engagement_score', 'overall_mood', 'chat_response_stats', 'stage_response_breakdown'];
        selectedData = [...selectedData, ...temp];
        selectedType = [...selectedType, 'critical_touchpoint_snapshot'];
      }
      if (this.touchpointHeatmap) {
        selectedData = [...selectedData, 'engagement_heatmap'];
        selectedType = [...selectedType, 'critical_touchpoint_heatmap'];
      }
      if (this.disengagedSnapshot) {
        const temp = ['overall_disengaged_stats', 'resolved_disengaged_stats', 'employee_to_meet_stats', 'disengaged_exited_employee_stats', 'disengaged_driver_analysis', 'monthwise_art', 'chat_resolution_insights'];
        selectedData = [...selectedData, ...temp];
        selectedType = [...selectedType, 'disengaged_employee_snapshot'];
      }
      if (this.disengagedMeet) {
        const temp = ['user_display_name', 'user_email', 'user_department', 'stage_title', 'completedAt', 'session_driver', 'overall_mood', 'driverAverage', 'transcripts', 'user_profile_id', 'status', 'action_status', 'createdAt', 'assignedTo', 'assignedTo_email', 'assignedTo_display_name', 'user_high_potential_emp'];
        selectedData = [...selectedData, ...temp];
        selectedType = [...selectedType, 'disengaged_employees_list'];
      }
      if (this.disengagedAnalysis) {
        const temp = ['formatted_response', 'response_sentiment', 'user_name', 'user_email', 'user_department', 'user_location', 'interaction_sub_driver', 'interaction_driver', 'user_profile_id'];
        selectedData = [...selectedData, ...temp];
      }
      reportFilters = {
        ...reportFilters,
        ...filters,
        report_type: 'dashboard',
        sheets: selectedType.length ? selectedType.join() : undefined,
        fields: selectedData.length ? selectedData.join() : undefined
      };
      // console.log('reportFilters', reportFilters);
      this.$store.dispatch('updateSnackbar', {
        color: 'warn',
        show: true,
        text: 'Generating report, Please wait!'
      });
      //  http://localhost:8000/feedback_bot/reports/download_analytics_excel_report?report_type=dashboard
      axios.get(`${process.env.VUE_APP_API_URL}reports/download_analytics_excel_report`, {
        params: reportFilters
      }).then((response) => {
        // console.log('response', response);
        if (response && response.data && response.data.success) {
          if (response.data.report_url) {
            this.downloadingFlag = false;
            this.$forceUpdate();
            setTimeout(() => {
              window.open(response.data.report_url);
            }, 100);
          } else {
            this.downloadingFlag = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to generate report, Please try again later!'
            });
          }
          this.reportDialog = false;
        } else {
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to generate report, Please try again later!'
          });
          this.downloadingFlag = false;
          this.reportDialog = false;
        }
        this.downloadingFlag = false;
      }).catch((err) => {
        if (err.response.status === 429) {
          // this.loading = false;
          // this.open = false;
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          // this.loading = false;
          // this.open = false;
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to generate report, Please try again later!'
          });
        }
      });
    },
    changeView () {
      const queryParams = {
        ...this.$route.query,
        tab: this.activeDashView
      };
      this.$router.push({
        path: '/',
        query: queryParams
      }).catch(() => {});
    },
    toggleDashFilter () {
      this.$emit('toggleDashFilter');
    },
    resetDashFilters () {
      this.$emit('resetDashFilters');
    }
  }
};
</script>

<style lang="scss" scoped>
.top-nav {
  // position: relative;
  padding-left: 30px;
  ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      position: relative;
      cursor: pointer;
      a {
        text-decoration: none;
      }
      .top-menu {
        // height: 55px;
        height: 48px;
        // border-top-left-radius: 0.375rem;
        border-top-left-radius: 0.5rem;
        // border-top-right-radius: 0.375rem;
        border-top-right-radius: 0.5rem;
        display: flex;
        align-items: center;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        // margin-right: 0.5rem;
        // margin-right: 0.25rem;
        // color: var(--color-text);
        color: var(--bg);
        font-size: var(--content-size);
        position: relative;
        .top-menu__title {
          margin-left: 0.25rem;
          display: flex;
          align-items: center;
          white-space: nowrap;
          .top-menu__sub-icon {
            transition-property: background-color,
            border-color, color, fill, stroke, opacity, box-shadow, transform;
            transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
            transition-duration: 100ms;
            width: 1rem;
            height: 1rem;
            margin-left: 0.5rem;
          }
        }
        &.top-menu--active {
          display: flex;
          // background-color: #faf8fb;
          background-color: #ffffff;
          color: var(--primary-color);
          .top-menu__icon {
            color: var(--primary-color);
          }
          .top-menu__title {
            color: var(--primary-color);
            font-weight: var(--heading-weight);
          }
          &::before {
            content: "";
            width: 20px;
            height: 20px;
            margin-left: -19px;
            transform: rotate(90deg) scale(1.04);
            background-size: 100%;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='259.51' height='259.52' viewBox='0 0 259.51 259.52'%3E%3Cpath id='Path_143' data-name='Path 143' d='M8659.507,423.965c-.167-2.608.05-5.319-.19-8.211-.084-1.012-.031-2.15-.118-3.12-.113-1.25-.1-2.682-.236-4.061-.172-1.722-.179-3.757-.365-5.394-.328-2.889-.478-5.857-.854-8.61-.509-3.714-.825-7.252-1.38-10.543-.934-5.535-2.009-11.312-3.189-16.692-.855-3.9-1.772-7.416-2.752-11.2-1.1-4.256-2.394-8.149-3.687-12.381-1.1-3.615-2.366-6.893-3.623-10.493-1.3-3.739-2.917-7.26-4.284-10.7-1.708-4.295-3.674-8.078-5.485-12.023-1.145-2.493-2.5-4.932-3.727-7.387-1.318-2.646-2.9-5.214-4.152-7.518-1.716-3.16-3.517-5.946-5.274-8.873-1.692-2.818-3.589-5.645-5.355-8.334-2.326-3.542-4.637-6.581-7.039-9.848-2.064-2.809-4.017-5.255-6.088-7.828-2.394-2.974-4.937-5.936-7.292-8.589-3.027-3.411-6.049-6.744-9.055-9.763-2.4-2.412-4.776-4.822-7.108-6.975-3-2.767-5.836-5.471-8.692-7.854-3.332-2.779-6.657-5.663-9.815-8.028-2.958-2.216-5.784-4.613-8.7-6.6-3.161-2.159-6.251-4.414-9.219-6.254-3.814-2.365-7.533-4.882-11.168-6.89-4.213-2.327-8.513-4.909-12.478-6.834-4.61-2.239-9.234-4.619-13.51-6.416-4.1-1.725-8.11-3.505-11.874-4.888-4.5-1.652-8.506-3.191-12.584-4.47-6.045-1.9-12.071-3.678-17.431-5-9.228-2.284-17.608-3.757-24.951-4.9-7.123-1.112-13.437-1.64-18.271-2.035l-2.405-.2c-1.638-.136-3.508-.237-4.633-.3a115.051,115.051,0,0,0-12.526-.227h259.51Z' transform='translate(-8399.997 -164.445)' fill='%23fff'/%3E%3C/svg%3E%0A");
            position: absolute;
            bottom: 0;
            left: 0;
          }
          &::after {
            content: "";
            width: 20px;
            height: 20px;
            margin-right: -19px;
            transform: rotate(180deg) scale(1.04);
            background-size: 100%;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='259.51' height='259.52' viewBox='0 0 259.51 259.52'%3E%3Cpath id='Path_143' data-name='Path 143' d='M8659.507,423.965c-.167-2.608.05-5.319-.19-8.211-.084-1.012-.031-2.15-.118-3.12-.113-1.25-.1-2.682-.236-4.061-.172-1.722-.179-3.757-.365-5.394-.328-2.889-.478-5.857-.854-8.61-.509-3.714-.825-7.252-1.38-10.543-.934-5.535-2.009-11.312-3.189-16.692-.855-3.9-1.772-7.416-2.752-11.2-1.1-4.256-2.394-8.149-3.687-12.381-1.1-3.615-2.366-6.893-3.623-10.493-1.3-3.739-2.917-7.26-4.284-10.7-1.708-4.295-3.674-8.078-5.485-12.023-1.145-2.493-2.5-4.932-3.727-7.387-1.318-2.646-2.9-5.214-4.152-7.518-1.716-3.16-3.517-5.946-5.274-8.873-1.692-2.818-3.589-5.645-5.355-8.334-2.326-3.542-4.637-6.581-7.039-9.848-2.064-2.809-4.017-5.255-6.088-7.828-2.394-2.974-4.937-5.936-7.292-8.589-3.027-3.411-6.049-6.744-9.055-9.763-2.4-2.412-4.776-4.822-7.108-6.975-3-2.767-5.836-5.471-8.692-7.854-3.332-2.779-6.657-5.663-9.815-8.028-2.958-2.216-5.784-4.613-8.7-6.6-3.161-2.159-6.251-4.414-9.219-6.254-3.814-2.365-7.533-4.882-11.168-6.89-4.213-2.327-8.513-4.909-12.478-6.834-4.61-2.239-9.234-4.619-13.51-6.416-4.1-1.725-8.11-3.505-11.874-4.888-4.5-1.652-8.506-3.191-12.584-4.47-6.045-1.9-12.071-3.678-17.431-5-9.228-2.284-17.608-3.757-24.951-4.9-7.123-1.112-13.437-1.64-18.271-2.035l-2.405-.2c-1.638-.136-3.508-.237-4.633-.3a115.051,115.051,0,0,0-12.526-.227h259.51Z' transform='translate(-8399.997 -164.445)' fill='%23fff'/%3E%3C/svg%3E%0A");
            position: absolute;
            bottom: 0;
            right: 0;
          }
        }
        &:not(.top-menu--active) .top-menu__icon:before {
          content: "";
          z-index: -1;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          border-top-left-radius: 0.5rem;
          border-top-right-radius: 0.5rem;
          transition-property: background-color,
          border-color, color, fill, stroke, opacity, box-shadow, transform;
          transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
          transition-duration: 100ms;
        }
      }
      @keyframes intro-active-menu-animation {
        100% {
          z-index: 0;
        }
      }
      @keyframes intro-menu-animation {
        100% {
          opacity: 1;
          transform: translateX(0px);
        }
      }
      &:hover .top-menu:not(.top-menu--active) {
        // background-color: var(--bg-panel);
        background-color: var(--bg);
        // background-color: #dde2e9;
        // background-color: #fbfcff;
        // background-color: #faf8fb;
        color: var(--primary-color);
      }
    }
  }
}
.export-data-heading {
  font-size: var(--heading-size);
  color: var(--color-text);
  font-weight: var(--heading-weight);
}
</style>

<style lang="scss">
.disable-action {
  .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: var(--bg) !important;
  }
}
</style>

<style scoped>
.top-nav[min-width~="1075px"] .top-menu {
  font-size: 14px !important;
}
.top-nav[min-width~="1120px"] .top-menu {
  font-size: 16px !important;
}
</style>
